/**
 * Module Federation entry point 
 */
import('./bootstrap');
